module.exports = __webpack_public_path__ + "static/media/react-logo.79075919.png";